import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";

export default function LegalPage({ sectionKey }) {
  const { locale, t, dict } = useI18n();
  const content = dict[sectionKey];

  return (
    <article className="mx-auto max-w-3xl px-5 py-16 md:px-8 md:py-20" data-testid={`${sectionKey}-page`}>
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#0f5c3f]">
        {t("brand.name")}
      </p>
      <h1
        className="mt-3 text-4xl leading-tight text-[#0b3d5c] md:text-5xl"
        style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
        data-testid={`${sectionKey}-title`}
      >
        {content.title}
      </h1>
      <p className="mt-3 text-xs text-[#6e8394]">{t("legalCommon.lastUpdated")}</p>
      <p className="mt-6 text-base leading-relaxed text-[#4b5f70]">{content.intro}</p>

      <div className="mt-10 space-y-8">
        {content.sections.map((s, idx) => (
          <section key={idx} data-testid={`${sectionKey}-section-${idx}`}>
            <h2 className="text-xl font-semibold text-[#0b3d5c]">{s.heading}</h2>
            <p className="mt-2 text-sm leading-relaxed text-[#4b5f70]">{s.body}</p>
          </section>
        ))}
      </div>

      <div className="mt-12">
        <Link
          to={`/${locale}`}
          className="inline-flex items-center gap-2 rounded-full bg-[#0f5c3f] px-6 py-3 text-sm font-semibold text-white hover:bg-[#0d4d35]"
          data-testid={`${sectionKey}-back-home`}
        >
          {t("legalCommon.backHome")}
        </Link>
      </div>
    </article>
  );
}
